module.exports = __webpack_public_path__ + "src/img/bIcon.db3092bc.png";